<template>
  <div class="hamburger" :class="{ open: menuOpened }">
    <div class="hamburger-open" @click="openMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="hamburger-close" @click="closeMenu">
      <span></span>
      <span></span>
      <div class="close-text">Close</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['menuOpened']),
  },
  methods: {
    ...mapMutations(['openMenu', 'closeMenu']),
  },
};
</script>

<style lang="scss" scoped>
.hamburger {
  @media (min-width: 768px) {
    margin-left: 30px;
  }
}
.hamburger {
  width: 30px;
  height: 26px;
  position: relative;
  cursor: pointer;
  top: -2px;
  span {
    display: block;
    transition: 0.25s ease-in-out;
    background: #f6acff;
  }
  &-open,
  &-close {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 2px;
  }
  &-open {
    span {
      width: 30px;
      height: 2px;
      position: relative;
      margin: 5px 0;
      &:nth-child(1) {
        transition-delay: 0.5s;
      }
      &:nth-child(2) {
        transition-delay: 0.625s;
      }
      &:nth-child(3) {
        transition-delay: 0.75s;
      }
    }
  }
  &-close {
    transform: rotate(45deg);
    z-index: -1;
    span {
      &:nth-child(1) {
        height: 0;
        width: 2px;
        position: absolute;
        top: -5px;
        left: 14px;
        transition-delay: 0s;
      }
      &:nth-child(2) {
        width: 0;
        height: 2px;
        position: absolute;
        left: 1px;
        top: 8px;
        transition-delay: 0.25s;
      }
      &:nth-child(3) {
        transition-delay: 0.75s;
      }
    }
  }
  &.open {
    .hamburger-open {
      z-index: -1;
      span {
        width: 0;
        &:nth-child(1) {
          transition-delay: 0s;
        }
        &:nth-child(2) {
          transition-delay: 0.125s;
        }
        &:nth-child(3) {
          transition-delay: 0.25s;
        }
      }
    }
    .hamburger-close {
      z-index: 1;
      span {
        &:nth-child(1) {
          height: 29px;
          transition-delay: 0.625s;
        }
        &:nth-child(2) {
          width: 29px;
          transition-delay: 0.375s;
        }
      }
    }
  }
}

.close-text {
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s;
  margin-left: 35px;
  transform: rotate(-45deg);
  margin-top: -19px;
  transition-delay: 1s;
  .open & {
    opacity: 1;
    visibility: visible;
  }
}
</style>
